export const UPDATE_SCHEDULER_JOB = 'SAGA/UPDATE_SCHEDULER_JOB';

export const updateSchedulerJob = (id, payload) => {
  return {
    type: UPDATE_SCHEDULER_JOB,
    id,
    payload,
  };
};
